
import React, { useState } from 'react';
import { store } from '../../../../../index';
import { reduxActions } from '../../../../../store'
import { IFile } from '../../../../../shared/interfaces';
import { DefaultButton, TextField } from '@fluentui/react';


export interface FromSharepointProps {
    target: string
    onFileChanged?: () => void;
}
type Props = FromSharepointProps

const FromSharepoint: React.FunctionComponent<Props> = props => {

    const [fileUrl, setFileUrl] = useState<string>('');

    const onUploadFileClick = async () => {
        const fileName = fileUrl.replace(/^.*[\\\/]/, '')
        if (fileUrl) {
            const data = await fetch(fileUrl);
            const blob = await data.blob();
            var reader = new FileReader();
            reader.readAsDataURL(blob);
            reader.onload = function () {
                if (reader.result) {
                    const docFile: IFile = {
                        fileName: fileName,
                        fileType: "Documento",
                        docBase64String: reader.result.toString().split(';base64,').pop(),
                        dimensionUnit: "KB"
                    }

                    switch (props.target) {
                        case 'documento':
                            store.dispatch(reduxActions.protocolWizardActions.setProtocol({ documentFile: docFile }));
                            store.dispatch(reduxActions.protocolWizardActions.setProtocolWizardTouched());
                            props.onFileChanged!();
                            break;
                        case 'allegati':
                            store.dispatch(reduxActions.protocolWizardActions.addAttachment(docFile));
                            store.dispatch(reduxActions.protocolWizardActions.setProtocolWizardTouched());
                            props.onFileChanged!();
                            break;

                    }

                }

            };
            reader.onerror = function (error) {
            };
        }
    }
    return <React.Fragment>
        <TextField
            label='Url file'
            defaultValue={fileUrl}
            onChange={
                (event, newValue) => {
                    if (newValue)
                        setFileUrl(newValue);
                }
            }
        />
        <DefaultButton
            text="Upload file"
            onClick={onUploadFileClick}
            allowDisabledFocus
        />
    </ React.Fragment>;
};


export default FromSharepoint;